import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreService } from './service/store.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    StoreService
  ]
})
export class StoreModule { }
